<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-18 09:32:49
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:47:38
 * @FilePath: /privacy-web/src/components/The/TheHeader.vue
-->
<template>
  <div class="header-main" :class="{ 'header-main-mobile': isMobile }">
    <div class="header-width">
      <TheLogo></TheLogo>
      <TheDropdown v-if="isMobile"></TheDropdown>
      <TheMenus v-else></TheMenus>
    </div>
  </div>
</template>
<script>
export default { name: "TheHeader" };
</script>
<style lang="scss" scoped>
.header-main {
  position: relative;
  z-index: 1999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc($multiple * 50px);
}

.header-width {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc($multiple * 1040px);
  min-width: calc($multiple * 1040px);
}

.header-main-mobile {
  position: relative;
  z-index: 1999;
  padding: 0 1.02rem;
  width: 19.2rem;
  height: 2.56rem;
  background: rgb(9 75 150 / 63%);
  backdrop-filter: blur(0.36rem);

  .header-width {
    width: 100%;
    min-width: 100%;
  }
}
// .header-main {
//   display: flex;
//   align-items: center;
//   padding-left: 2.67rem;
//   width: 100%;
//   height: 0.93rem;
//   background: #fff;
//   box-shadow: 0 1px 11px 0 rgb(0 0 0 / 6%), 0 0 6px 0 rgb(0 0 0 / 10%);
// }
// .header-main-mobile {
//   padding-left: 1.02rem;
//   width: 19.20rem;
//   height: 2.61rem;
//   background: rgba(9, 75, 150, .63);
//   backdrop-filter: blur(.36rem);
// }
</style>
